module.exports = __webpack_public_path__ + "static/img/server_error.3543e6cd.svg";